import React from 'react';

import { NumberFieldProps, FieldNumber } from './FieldNumber';

export type IncrementFieldProps = Omit<NumberFieldProps, 'prefix'> & {
    increment: number;
};

export const FieldIncrement = ({ ...props }: IncrementFieldProps) => (
    <FieldNumber
        {...{
            ...props,
            prefix: '',
        }}
    />
);
